import { API } from "@/services/api";
import type { GoogleCalendarConnection } from "@/types/google-calendar.types";

const ENDPOINT = "/integrations/google-calendar";

export async function getGoogleCalendar(): Promise<GoogleCalendarConnection> {
  const res = await API.Get<GoogleCalendarConnection>(ENDPOINT);
  if (!res.data) throw new Error(res.message);
  return res.data;
}

export async function connectGoogleCalendar(): Promise<string> {
  // The HttpOnly state cookie binds the OAuth callback to this browser.
  const res = await API.Post<{ origin: string }, { url: string }>(
    `${ENDPOINT}/connect`, { origin: window.location.origin }, { withCredentials: true },
  );
  if (!res.data) throw new Error(res.message);
  return res.data.url;
}

export async function syncGoogleCalendar(): Promise<GoogleCalendarConnection> {
  const res = await API.Post<never, GoogleCalendarConnection>(`${ENDPOINT}/sync`);
  if (!res.data) throw new Error(res.message);
  return res.data;
}

export async function disconnectGoogleCalendar(): Promise<GoogleCalendarConnection> {
  const res = await API.Delete<never, GoogleCalendarConnection>(ENDPOINT);
  if (!res.data) throw new Error(res.message);
  return res.data;
}
